window.applyQuantityDiscountForCustomInput = function(amount) {

    const container = document.querySelector('.js-quantity-discounts');
    container?.classList.remove('js-hidden', 'hidden');
    container?.classList.add('visible');

    const items = document.querySelectorAll('.js-quantity-discounts__item');
    const savedAmountEl = document.querySelector('.js-quantity-discounts__saved-amount');

    const origPrice =
        Number(document.querySelector('.quantity-discounts__table')?.dataset.origPrice)
        || Number(document.querySelector('.price-final strong')?.dataset.priceWithVat)
        || Number(shoptet?.product?.priceWithVat);

    if (!items.length || !origPrice) return;

    const matchedAmount = Math.max(
        ...Array.from(items)
            .map(i => Number(i.dataset.amount))
            .filter(a => a <= amount)
    );

    const matchedItem = document.querySelector(`.js-quantity-discounts__item[data-amount="${matchedAmount}"]`);
    if (!matchedItem) return;

    document
        .querySelector('.quantity-discounts__item--highlighted')
        ?.classList.remove('quantity-discounts__item--highlighted');
    matchedItem.classList.add('quantity-discounts__item--highlighted');

    const ratio = Number(matchedItem.dataset.priceRatio);
    const saved = amount * (origPrice - origPrice * ratio);

    if (savedAmountEl) {
        savedAmountEl.textContent = saved.ShoptetFormatAsCurrency();
    }
};
